import React, { Component } from "react";

import { Layout } from "antd";

import Template from "../Common/Template/Template";
import { TEMPLATE_SIDES } from "../Common/Template/TemplateContext";
import PageBreadcrumb from "../Common/UIComponents/PageBreadcrumb";
import SideNav, { getSideNavCollapsed } from "../Common/UIComponents/SideNav";
import PaymentPendingBanner from "../grace-period/components/PaymentPendingBanner";
import Analytics from "./Analytics/Analytics";
import Report from "./Report/Report";

import { hasPermission, permissions } from "../../utils/Permissions";

import { ReactComponent as AnalyticsIcon } from "../../assets/images/feature-icons/AnalyticsOutlined.svg";
import { ReactComponent as ReportIcon } from "../../assets/images/feature-icons/ReportOutlined.svg";
import { ReactComponent as TemplateIcon } from "../../assets/images/feature-icons/TemplateOutlined.svg";

import "./Product.css";

const { Sider, Content } = Layout;

class Reports extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      activeTab: "1",
      sideNavCollapsed: getSideNavCollapsed(),
    };

    this.handleSelect = this.handleSelect.bind(this);
    this.handleSideNavCollapsedChange = this.handleSideNavCollapsedChange.bind(this);
  }

  componentDidMount() {
    const { onChangeReport } = this.props;
    this._isMounted = true;
    if (this._isMounted) {
      const url = window.location.href;
      let activeTab = "1";
      let subUrl = "report";

      const hasTemplateAccess = hasPermission(permissions.product.template);
      const hasAnalyticsAccess = hasPermission(permissions.product.analytics);

      if (url.includes("/report")) {
        activeTab = "1";
        subUrl = "report";
      } else if (url.includes("/template")) {
        if (hasTemplateAccess) {
          activeTab = "2";
          subUrl = "template";
        } else {
          activeTab = "1";
          subUrl = "report";
        }
      } else if (url.includes("/analytics")) {
        if (hasAnalyticsAccess) {
          activeTab = "3";
          subUrl = "analytics";
        } else {
          activeTab = "1";
          subUrl = "report";
        }
      }
      if (this._isMounted) {
        this.setState({ activeTab });
      }
      onChangeReport(subUrl);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleSelect(selectedTab) {
    const { history } = this.props;
    if (this._isMounted) {
      const hasTemplateAccess = hasPermission(permissions.product.template);
      const hasAnalyticsAccess = hasPermission(permissions.product.analytics);

      this.setState({ activeTab: selectedTab }, () => {
        if (selectedTab === "1") {
          history.replace("/product/report");
        } else if (selectedTab === "2" && hasTemplateAccess) {
          history.replace("/product/template");
        } else if (selectedTab === "3" && hasAnalyticsAccess) {
          history.replace("/product/analytics");
        } else {
          this.setState({ activeTab: "1" });
          history.replace("/product/report");
        }
      });
    }
  }

  handleSideNavCollapsedChange(collapsed) {
    if (this._isMounted) {
      this.setState({ sideNavCollapsed: collapsed });
    }
  }

  render() {
    const { history } = this.props;
    const { activeTab, sideNavCollapsed } = this.state;

    const tabItems = [
      {
        key: "1",
        label: "Report",
        breadcrumbLabel: "Reports",
        icon: <ReportIcon />,
        content: <Report history={history} />,
      },
      hasPermission(permissions.product.template) && {
        key: "2",
        label: "Template",
        breadcrumbLabel: "Template",
        icon: <TemplateIcon />,
        content: <Template history={history} side={TEMPLATE_SIDES.PRODUCT} />,
      },
      hasPermission(permissions.product.analytics) && {
        key: "3",
        label: "Analytics",
        breadcrumbLabel: "Analytics",
        icon: <AnalyticsIcon />,
        content: <Analytics history={history} />,
      },
    ].filter(Boolean);

    const sideNavItems = tabItems.map(({ key, label, icon }) => ({
      key,
      label,
      icon,
    }));

    const activeItem = tabItems.find((item) => item.key === activeTab) || tabItems[0];

    return (
      <div className="prodMainContainer">
        {this._isMounted ? (
          <>
            {activeItem && (
              <PageBreadcrumb
                items={[
                  { label: "Products" },
                  { label: activeItem.breadcrumbLabel },
                ]}
                showBack={false}
              />
            )}
            <Layout className="ProductLayout">
              <Sider
                width={220}
                collapsedWidth={64}
                collapsed={sideNavCollapsed}
                theme="light"
                trigger={null}
                className="ProductLayout__Sider"
              >
                <SideNav
                  ariaLabel="Product navigation"
                  items={sideNavItems}
                  activeKey={activeTab}
                  collapsed={sideNavCollapsed}
                  onCollapsedChange={this.handleSideNavCollapsedChange}
                  onItemClick={(item) => this.handleSelect(item.key)}
                />
              </Sider>
              <Content className="ProductLayout__Content">
                <PaymentPendingBanner />
                {activeItem && (
                  <div
                    className={`ProductLayout__Body${
                      activeTab === "1" ? " ProductLayout__Body--overflow-auto" : ""
                    }`}
                  >
                    {activeItem.content}
                  </div>
                )}
              </Content>
            </Layout>
          </>
        ) : null}
      </div>
    );
  }
}

export default Reports;
